import type { RouteRecordRaw } from 'vue-router'

import { PaymentFlow } from '@backmarket/nuxt-layer-payment/pages/config/flows'
import { getRedirectOnPaymentDomainMiddleware } from '@backmarket/nuxt-layer-payment/pages/navigation/getRedirectOnPaymentDomainMiddleware'

import { ROUTES } from '~/scopes/auth/route-names'

import { INSURANCE } from './routes.constants'

const routes: RouteRecordRaw[] = [
  {
    path: 'post-purchase/insurance/:policyId/due',
    name: INSURANCE.DUE_PAYMENT,
    component: () =>
      import('~/scopes/insurance/pages/DueInsurance/DueInsurance.vue'),
    meta: {
      middleware: getRedirectOnPaymentDomainMiddleware(
        PaymentFlow.INSURANCE_DUE_AMOUNT,
        (to) => ({ policyId: to.params.policyId as string }),
      ),
      owners: ['bot-squad-b2cservices-front'],
      layout: false,
      auth: {
        required: true,
        redirection: {
          name: ROUTES.AUTH.LOGIN,
          query: { bm_journey: 'checkout' },
        },
      },
    },
  },
  {
    path: 'post-purchase/insurance/:policyId/due/result',
    name: INSURANCE.DUE_PAYMENT_RESULT,
    component: () =>
      import('~/scopes/insurance/pages/DueInsurance/DueInsurancePaymentResult.vue'),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      auth: {
        required: true,
        redirection: {
          name: ROUTES.AUTH.LOGIN,
          query: { bm_journey: 'checkout' },
        },
      },
    },
  },
  {
    path: 'post-purchase/insurance/due/completed',
    name: INSURANCE.DUE_PAYMENT_COMPLETED,
    component: () =>
      import('~/scopes/insurance/pages/DueInsurance/DueInsuranceCompleted.vue'),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      auth: {
        required: true,
        redirection: {
          name: ROUTES.AUTH.LOGIN,
          query: { bm_journey: 'checkout' },
        },
      },
    },
  },
  {
    path: 'post-purchase/insurance',
    name: INSURANCE.POST_PURCHASE,
    component: () =>
      import('~/scopes/insurance/pages/PostPurchase/PostPurchase.vue'),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      layout: false,
      auth: {
        required: true,
        redirection: {
          name: ROUTES.AUTH.LOGIN,
          query: { bm_journey: 'checkout' },
        },
      },
    },
  },
  {
    path: 'post-purchase/insurance/expired',
    name: INSURANCE.EXPIRED,
    component: () => import('~/scopes/insurance/pages/Expired/Expired.vue'),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
    },
  },
  {
    path: 'post-purchase/insurance/subscribed',
    name: INSURANCE.SUBSCRIBED,
    component: () =>
      import('~/scopes/insurance/pages/Subscribed/Subscribed.vue'),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
    },
  },

  // Backwards compatible route for old url
  {
    path: 'checkout',
    redirect: ({ query }) => ({ name: INSURANCE.POST_PURCHASE, query }),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
    },
  },
]

export default routes
